import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Col, Row, Form } from "react-bootstrap";
import { AuthContext } from "../../auth/AuthContext";
import {
  SelectMultipleHeader,
  TablaBonos24k,
  TablaBonosBuenaRacha,
  TablaBonosDiamante,
  TablaBonosEscalones,
  TablaBonosMalaRacha,
  TablaBonosPago,
  TablaBonosReporteMensual,
  TablaBonosTeExtranamos,
} from "../../Components/Components";
import {
  SelectOficinas,
  SelectOficinas2,
} from "../../Components/SelectOficinas/SelectOficinas";
import "../../pages/Dashboard/dashboard.css";
import moment, { months } from "moment";
import "moment/locale/es";
moment.locale("mx");

export const Bonos = ({ initState, updateState }) => {
  const { usuario } = useContext(AuthContext);

  const ref = useRef(null);
  const currentYear = new Date().getFullYear();
  const currentMonth = moment().format("MMMM");

  const { openMenu } = initState;
  const [isSticky, setSticky] = useState(false);
  const [dataSelected, setDataSelected] = useState({});
  const [selectOficina, setSelectOficina] = useState("");
  const [nombreOficina, setNombreOficina] = useState("");
  const [selectedInsignias, setSelectedInsignias] = useState("0");
  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(moment().month(currentMonth).format('M'));
  const [load, setLoad] = useState(false);

  const [dataDiamante, setDataDiamante] = useState([]);
  const [data24k, setData24k] = useState([]);
  const [dataBuenaRacha, setDataBuenaRacha] = useState([]);
  const [dataMalaRacha, setMalaRacha] = useState([]);
  const [dataTeExtranamos, setDataTeExtranamos] = useState([]);
  const [dataEscalones, setDataEscalones] = useState([]);
  const [dataReporteMensual, setDataReporteMensual] = useState([]);
  const [dataAgentesPagoBonos, setDataAgentesPagoBonos] = useState([]);
  const [sendReport, setSendReport] = useState(false);

  const insignias = [
    { label: "Diamante", value: 0 },
    { label: "24k", value: 1 },
    { label: "Buena Racha", value: 2 },
    { label: "Mala Racha", value: 3 },
    { label: "Te extrañamos", value: 4 },
    { label: "Escalones", value: 5 },
    { label: "Bonos", value: 6 },
    { label: "Reporte Mensual", value: 7 },
  ];
  const [titleTable, setTitleTable] = useState(insignias[0].label);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  }, []);

  useEffect(() => {
    if (selectedInsignias == "0") {
      getInsigniasAnuales();
    }

    if (selectedInsignias == "1") {
      getInsigniasMensuales();
    }

    if (selectedInsignias == "2") {
      getInsigniasDiarias();
    }

    if (selectedInsignias == "3") {
      getInsigniasInactividadDecena();
    }

    if (selectedInsignias == "4") {
      getInsigniasInactividadMensual();
    }

    if (selectedInsignias == "5") {
      getInsigniasEscalonBono();
    }

    if (selectedInsignias == "6") {
      getAgentesPagoBonos();
    }

    if (selectedInsignias == "7") {
      getAgentesResumenMensual();
    }
  }, [selectOficina, year, selectedInsignias, month]);

  return (
    <div className={`ws_content_wrapper ${!openMenu ? "wrapper_close" : ""}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
        <Container
          fluid
          className={`ws_header_fixed ${isSticky ? "shadow" : ""} mt-st-7`}
          ref={ref}
          style={{ borderBottom: "1px solid #ccc" }}
        >
          <Row>
            <Col className="mb-2" xs={12} md={3}>
              <h1 className="ws_title_header">Logros</h1>
            </Col>
            <Col xs={12} md={4}>
              <h3 className="ws_select_type" style={{ color: "#0ca1b4" }}>
                Insignias
              </h3>
              <Form.Select
                className="ws_select_opt"
                aria-label="Default select example"
                value={selectedInsignias}
                id="insignias"
                name="insignias"
                onChange={(e) => {
                  setTitleTable(
                    insignias.find((element) => element.value == e.target.value)
                      .label
                  );
                  setSelectedInsignias(e.target.value);
                }}
              >
                {insignias.map((element, index) => (
                  <option value={element.value} key={index}>
                    {element.label}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <SelectOficinas2
              onChange={(e) => {
                setSelectOficina(e.target.value);
                setNombreOficina(e.target.selectedOptions[0].text);
              }}
            />
            {/* <Col className="mb-2" xs={12} md={9}>
              <SelectMultipleHeader initState={initState} index={0} setDataSelected={setDataSelected} />
            </Col> */}
          </Row>
        </Container>
        <Container fluid className="mt-5">
          <Row>
            {selectedInsignias == "0" ? (
              <TablaBonosDiamante
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                load={load}
                setLoad={setLoad}
                data={dataDiamante}
                setData={setDataDiamante}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "1" ? (
              <TablaBonos24k
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                load={load}
                setLoad={setLoad}
                data={data24k}
                setData={setData24k}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "2" ? (
              <TablaBonosBuenaRacha
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                month={month}
                setMonth={setMonth}
                load={load}
                setLoad={setLoad}
                data={dataBuenaRacha}
                setData={setDataBuenaRacha}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "3" ? (
              <TablaBonosMalaRacha
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                load={load}
                setLoad={setLoad}
                data={dataMalaRacha}
                setData={setMalaRacha}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "4" ? (
              <TablaBonosTeExtranamos
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                month={month}
                setMonth={setMonth}
                load={load}
                setLoad={setLoad}
                data={dataTeExtranamos}
                setData={setDataTeExtranamos}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "5" ? (
              <TablaBonosEscalones
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                month={month}
                setMonth={setMonth}
                load={load}
                setLoad={setLoad}
                data={dataEscalones}
                setData={setDataEscalones}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "6" ? (
              <TablaBonosPago
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                month={month}
                setMonth={setMonth}
                load={load}
                setLoad={setLoad}
                data={dataAgentesPagoBonos}
                setData={setDataAgentesPagoBonos}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : selectedInsignias == "7" ? (
              <TablaBonosReporteMensual
                state={initState}
                updateState={updateState}
                dataSelected={dataSelected}
                year={year}
                setYear={setYear}
                month={month}
                setMonth={setMonth}
                load={load}
                setLoad={setLoad}
                data={dataReporteMensual}
                claveOficina={selectOficina}
                nombreOficina={nombreOficina}
                setData={setDataReporteMensual}
                selectOficina={selectOficina}
                sendReport={sendReport}
                setSendReport={setSendReport}
              />
            ) : null}
          </Row>
        </Container>
      </div>
    </div>
  );

  function getInsigniasAnuales() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInsigniasAnuales`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setDataDiamante(newData);
        setLoad(false);
      });
  }

  function getInsigniasMensuales() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInsigniasMensuales`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setData24k(newData);
        setLoad(false);
      });
  }

  function getInsigniasDiarias() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInsigniasDiarias`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
          month,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setDataBuenaRacha(newData);
        setLoad(false);
      });
  }

  function getInsigniasInactividadDecena() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInsigniasInactividadDecena`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.agentes;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setMalaRacha(newData);
        setLoad(false);
      });
  }

  function getInsigniasInactividadMensual() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInsigniasInactividadMensual`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
          month,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setDataTeExtranamos(newData);
        setLoad(false);
      });
  }

  function getInsigniasEscalonBono() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInsigniasEscalonBono`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
          month,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setDataEscalones(newData);
        setLoad(false);
      });
  }

  function getAgentesResumenMensual() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAgentesResumenMensual`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
          month,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setDataReporteMensual(newData);
        setLoad(false);
      });
  }

  function getAgentesPagoBonos() {
    setLoad(true);
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAgentesPagoBonos`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          id_login: usuario.id_usuario,
          clave_oficina: selectOficina,
          year,
          month,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let newData = res.list;
        newData.forEach((t, e) => {
          t.checked = false;
          t.idObj = e;
        });
        setDataAgentesPagoBonos(newData);
        setLoad(false);
      });
  }

  function handleScroll() {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled > 0 ? setSticky(true) : setSticky(false);
  }
};
